import type { StatusVariant } from '../patterns';

/**
 * Nutrition session status → StatusPill variant.
 *
 * Colours deliberately mirror the Protection (spray) session pills
 * (see `components/spray/statusPills/SessionStatusPill.tsx`) so the two
 * modules read the same. `signed_off` has no spray equivalent and keeps
 * green (`ok`) to mirror the completion semantic.
 *
 * Single source of truth — imported by every nutrition page that renders a
 * session status pill (Sessions, My-Sessions, the two session detail pages,
 * and the soil field page) so the mapping can never drift between them.
 */
export const SESSION_STATUS_VARIANT: Record<string, StatusVariant> = {
  draft: 'info',
  planned: 'warn',
  not_started: 'warn',
  in_progress: 'ok',
  completed: 'info',
  incomplete: 'danger',
  cancelled: 'danger',
  deleted: 'info',
  signed_off: 'ok',
};
